import PropTypes from "prop-types";
import React from "react";
import classNames from "classnames";

import { CONTENT_TYPE_TO_URL } from "config/constants/editor";
import getEditorURL from "editor/utils/getEditorURL";

import { Link } from "react-router-dom";

import CurationDate from "curation/components/CurationDate";
import DashboardHeadline from "dashboard/components/DashboardHeadline";
import StatusIcon from "dashboard/components/StatusIcon";

import styles from "./CurationListItem.css";

export default class CurationListItem extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { curation } = this.props;

    const editorUrl = getEditorURL(
      CONTENT_TYPE_TO_URL[curation.content_type],
      curation.id
    );

    const hasSeries = Boolean(curation.series);

    return (
      <Link to={editorUrl} className={styles.root} data-cy="curationItemLink">
        <div className={styles.statusContainer}>
          <StatusIcon status={curation.status} />
        </div>

        <div className={styles.headlineContainer}>
          <DashboardHeadline
            headline={curation.title}
            id={curation.id}
            isPrivate={false}
            type={curation.content_type}
          />
          <CurationDate
            created_date={curation.created_date}
            published_date={curation.published_date}
            status={curation.status}
          />
        </div>

        <div
          className={classNames(styles.seriesContainer, {
            [styles.noSeries]: !hasSeries,
          })}
        >
          {hasSeries ? curation.series : "No series"}
        </div>
      </Link>
    );
  }
}

CurationListItem.propTypes = {
  story: PropTypes.object.isRequired,
};
